export default __webpack_public_path__ + "static/media/2271.fb173ad8.png";